import BaseModelAPI from '../BaseModelAPI';

export default class SuratJalanSupplyForSubcontractList extends BaseModelAPI {

	static entity = 'list'
	static entityName = 'suratjalansupplyforsubcontract';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
